var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{staticClass:"heroicon-ui",attrs:{"d":"M11 14.59V3a1 1 0 0 1 2 0v11.59l3.3-3.3a1 1 0 0 1 1.4 1.42l-5 5a1 1 0 0 1-1.4 0l-5-5a1 1 0 0 1 1.4-1.42l3.3 3.3zM3 17a1 1 0 0 1 2 0v3h14v-3a1 1 0 0 1 2 0v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-3z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }